import C1 from './C001.jpg'
import C2 from './C002.jpg'
import C3 from './C003.jpg'
import C4 from './C004.jpg'
import C5 from './C005.jpg'
import C6 from './C006.jpg'
import C7 from './C007.jpg'
import C8 from './C008.jpg'
import C9 from './C009.jpg'
import C10 from './C010.jpg'
import C11 from './C011.jpg'
import C12 from './C012.jpg'
import C13 from './C013.jpg'
import C14 from './C014.jpg'
import C15 from './C015.jpg'
import C16 from './C016.jpg'
import C17 from './C017.jpg'
import C18 from './C018.jpg'
import C19 from './C019.jpg'
import C20 from './C020.jpg'
import C21 from './C021.jpg'
import C22 from './C022.jpg'
import C23 from './C023.jpg'
import C24 from './C024.jpg'
import C25 from './C025.jpg'
import C26 from './C026.jpg'
import C27 from './C027.jpg'
import C28 from './C028.jpg'
import C29 from './C029.jpg'
import C30 from './C030.jpg'
import C31 from './C031.jpg'
import C32 from './C032.jpg'
import C33 from './C033.jpg'
import C34 from './C034.jpg'
import C35 from './C035.jpg'

// const imgArray = ['../images/carousel/C001.jpg',
// '../images/carousel/C002.jpg',
// '../images/carousel/C003.jpg',
// '../images/carousel/C004.jpg',
// '../images/carousel/C005.jpg',
// '../images/carousel/C006.jpg',
// '../images/carousel/C007.jpg',
// '../images/carousel/C008.jpg',
// '../images/carousel/C009.jpg']
const imgArray = [C1,C2,C3,C4,C5,C6,C7,C8,C9,C10,C11,C12,C13,C14,C15,C16,C17,C18,C19,C20,C21,C22,C23,C24,C25,C26,C27,C28,C29,C30,C31,C32,C33,C34,C35]

export default imgArray


// WEBPACK FOOTER //
// ./src/images/carousel/index.ts